import { render, staticRenderFns } from "./fccVagasReservadas.vue?vue&type=template&id=250b5f94"
import script from "./fccVagasReservadas.vue?vue&type=script&lang=js"
export * from "./fccVagasReservadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports